import { FC, ReactNode } from 'react';
import { cx } from '@/utils/cx';

export type InfoTableRowProps = {
  label: string;
  value: ReactNode;
  labelClassName?: string;
  valueClassName?: string;
};

export const InfoTableRow: FC<InfoTableRowProps> = ({
  label,
  value,
  labelClassName,
  valueClassName,
}) => (
  <div className="flex flex-row justify-between border-b border-gray-200 py-3 text-sm font-medium">
    <div className={cx('text-gray-500', labelClassName)}>{label}</div>
    <div className={valueClassName}>{value}</div>
  </div>
);
